import React from "react";
import { Link } from "react-router-dom";

import Navbar from "../../../components/navbar";
import Footer from "../../../components/footer";
import Switcher from "../../../components/switcher";


import ScrollToTop from "../../../components/scroll-to-top";

export default function Shipping(){
    return(
        <>
        <Navbar navClass="defaultscroll is-sticky"/>
        <section className="relative table w-full py-32 lg:py-40 bg-gray-50 dark:bg-slate-800">
            <div className="container relative">
                <div className="grid grid-cols-1 text-center mt-10">
                    <h3 className="text-3xl leading-normal font-semibold">Shipping Policy</h3>
                    <p3>Learn how we collect, use, and protect your personal information with our detailed Shipping policy.</p3>
                </div>
            </div>
            
            <div className="absolute text-center z-10 bottom-5 start-0 end-0 mx-3">
                <ul className="tracking-[0.5px] mb-0 inline-block">
                    <li className="inline-block uppercase text-[13px] font-bold duration-500 ease-in-out hover:text-orange-500"><Link to="/">Sportyfi</Link></li>
                    <li className="inline-block text-base text-slate-950 dark:text-white mx-0.5 ltr:rotate-0 rtl:rotate-180"><i className="mdi mdi-chevron-right"></i></li>
                    <li className="inline-block uppercase text-[13px] font-bold duration-500 ease-in-out hover:text-orange-500"><Link to="">Policies</Link></li>
                    <li className="inline-block text-base text-slate-950 dark:text-white mx-0.5 ltr:rotate-0 rtl:rotate-180"><i className="mdi mdi-chevron-right"></i></li>
                    <li className="inline-block uppercase text-[13px] font-bold text-orange-500" aria-current="page">Shipping Policy</li>
                </ul>
            </div>
        </section>

         <section className="py-10 px-6 max-w-4xl mx-auto text-gray-800 leading-relaxed">
      

      {/* Delivery Charges */}
      <h2 className="text-2xl font-semibold mb-3">*What are the delivery charges?</h2>
      <ul className="list-disc pl-6 mb-6 space-y-2">
        <li>Shipping charges start at <strong>Rs.49/-</strong> on pre-payment orders (Fast Delivery).</li>
        <li>Shipping charges may vary according to the seller and product.</li>
        <li>If you place an order with <strong>COD</strong> option, an extra shipping charge of Rs.49/- applies (Standard Delivery).</li>
        <li>Charges apply only across India.</li>
        <li>Save money and time by choosing pre-payment at checkout.</li>
      </ul>

      {/* Estimated Delivery Time */}
      <h2 className="text-2xl font-semibold mb-3">2. Estimated Delivery Time</h2>
      <p className="mb-6">
        We deliver products as fast as possible. Orders placed are processed within <strong>2 working days</strong> and shipped accordingly. 
        Delivery time may vary based on your location, but we strive for fast delivery. Estimated delivery is <strong>3–5 working days</strong> after the order is placed and shipped.
      </p>

      {/* Hidden Costs */}
      <p2 className="text-2xl font-semibold mb-3">Are there any hidden costs (sales tax, octroi etc) on items sold by sportyfi and More ?</p2>
      <p className="mb-6">
        There are <strong>NO hidden charges</strong> when you purchase from sportyfi. List prices are final and all-inclusive (no sales tax, octroi, or extra fees).
      </p>

      {/* Delivery Restrictions */}
      <p2 className="text-2xl font-semibold mb-3">sportyfi does not/cannot ship to my area. Why ?</p2>
      
       
      <ul className="list-disc pl-6 mb-6 space-y-2">
        <li>Some Pin code not cover by shipping partner than issue facing by customer.
      </li>
        <li>if your order place on sportyfi.in and payment paid or we don’t able to delivery of product at your location than Don’t worry we refund your amount in your account but it’s possible only some conditions who’s listed below :</li>
        <li>1. Product out of stock</li>
        <li>2. Delivery Not Possible at customer Location</li>
        <li>*all rights reserved by sportyfi.in against refund policy.</li>
       
      </ul>
      

     
      
      <p>
       Our Delivery Partner Provide Order Tracking Service. Track Your Order Login into My Account and Order Tracking Page
      </p>
    </section>
        <Footer/>
        <Switcher/>
        <ScrollToTop/>
        </>
    )
}